module.exports = __webpack_public_path__ + "img/banner-7.a6ec1125.jpg";